import { render, staticRenderFns } from "./dynamic-document-signature-field-template.vue?vue&type=template&id=427fe784&scoped=true&"
import script from "./dynamic-document-signature-field-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-signature-field-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-signature-field-template.vue?vue&type=style&index=0&id=427fe784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427fe784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})
